import {Vue, Component, Prop, Inject} from "vue-property-decorator";
import {AppSettings} from "~/lib/app-settings";

import "./resource-picker.scss";

@Component
export class ResourcesPicker extends Vue {

  @Prop({type:Array, default: () => []}) preSelect:any[]
  @Prop({ type: Function, required:true}) service;
  @Prop({ type: Function, default: resource => (resource.label || resource.name )}) nameParser;

  @Inject() appSettings: AppSettings;

  private isLoading = false;
  private selection: any[] = [];
  private filter:string = "";
  private allSelected = false;
  private resources:any[] = [];

  async created(){
    this.isLoading = true;  this.selection = [...this.preSelect];

    this.resources = [...await this.service(this.appSettings.clientUUID)];
    this.isLoading = false;
  }

  get displayedResources() {
    const filter = this.filter.toLowerCase();
    if (!filter) return this.resources;
    return this.resources.filter(resource => (resource.label || resource.name).toLowerCase().includes(filter));
  }

  isSelected(resource) {
    return this.selection.some(({ id }) => resource.id === id);
  }

  select(resource) {
    if (this.isSelected(resource)) {
      this.selection = this.selection.filter(({ id }) => id !== resource.id);
      return;
    }
    this.selection = [...this.selection, resource];
  }

  handleComfirm() {
    this.$emit("select", this.selection);
  }

  handleAllSelect() {
    let z = [];
    if (!this.allSelected) {
      this.displayedResources.map(_ => (z.push(_)));
    }
    this.selection = z;
    this.allSelected = !this.allSelected;
  }

  renderContent() {
    return (
      <div>
        <div class="field">
          <input type="text" class="input" placeholder="Filtrer par nom" v-model={this.filter} />
        </div>
        <div class="scroller">
          <table class="table is-hoverable is-fullwidth">
            <thead>
            <tr>
              <th>Nom</th>
            </tr>
            </thead>
            <tbody>
            {this.displayedResources.map(r => (
              <tr key={r.id} onClick={() => this.select(r)} class={`${this.isSelected(r) ? "selected" : ""}`}>
                <td>{this.nameParser(r)}</td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div class="resources-picker modal is-active ">
        <div class="modal-background" />
        <div class="modal-card">
          <div class="modal-card-head" >
            <button class="button" type="button" onClick={this.handleAllSelect}>{!this.allSelected ? "Tout sélectionner" : "Tout détacher"}</button>
          </div>
          <section class="modal-card-body">
            {this.renderContent()}
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" onClick={() => this.$emit("cancel")}>Annuler</button>
            <button class="button" type="button" onClick={this.handleComfirm}>Selectionner</button>
          </footer>
        </div>
      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-4724baa6/resources-picker.tsx" });